module.exports = __webpack_public_path__ + "img/PurpleRobe.cfbde947.gif";